import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ExportTriggerState } from './export-trigger.model';
import { ExportTriggerStore } from './export-trigger.store';

@Injectable({ providedIn: 'root' })
export class ExportTriggerStoreQuery extends QueryEntity<ExportTriggerState> {
  constructor(protected store: ExportTriggerStore) {
    super(store);
  }
}
